__turbopack_context__.v({
  "HighlightsCarousel__SmallTitle": "HighlightsCarousel-module-scss-module__GUvF0G__HighlightsCarousel__SmallTitle",
  "HighlightsCarousel__SubTitle": "HighlightsCarousel-module-scss-module__GUvF0G__HighlightsCarousel__SubTitle",
  "HighlightsCarousel__TextContainer": "HighlightsCarousel-module-scss-module__GUvF0G__HighlightsCarousel__TextContainer",
  "HighlightsCarousel__Title": "HighlightsCarousel-module-scss-module__GUvF0G__HighlightsCarousel__Title",
  "HighlightsCarousel__Title__Pinned": "HighlightsCarousel-module-scss-module__GUvF0G__HighlightsCarousel__Title__Pinned",
});
